import React, {Component, useEffect, useState } from 'react';
import { useParams } from 'react-router';



import Header from '../header';
import GeneralInformation from './GeneralInformation';
import api from '../../api';
import DataTable, { Field } from '../../components/data-table/DataTable';
import { DateView, TextView } from '../../components/view-fields';
import './DefSummary.scss';
import { DateFormats, tryFormatDate } from '../../utils/date-utils';
import CheckList from './CheckList';

const DefensiveReport = () => {
  const { id } :any= useParams();
  const search = window.location.search;
  const [data, setData] = useState<any | undefined>({});

  useEffect(() => {
    if (id) {
      api.user.getDefensiveReport(id).then((response) => {
        if (response.status === 200) {
          setData(response.data.report);
        } else {
          setData({});
        }
      });
    }
  }, [id]);


  const renderTotalScore = () => {
    return (
      <div className="PaymentSummary__item">
        <label className="PaymentSummary__label">Total Score (<small>Development Outcomes</small>)</label>
        <span className="PaymentSummary__value">{data?.mark}</span>
      </div>
    );
  };
  const renderRemarks = () => {
    return (
      <div className="PaymentSummary__item">
        <label className="PaymentSummary__label">Assessor Remarks</label>
        <div className="PaymentSummary__outer">
          <span className="">
            {data?.assessorComments || "--"}
          </span>
        </div>
      </div>
    );
  };
    const testDate = () => {
    const paymentMode: string ='Full Payment';
    return (
      <div className="PaymentSummary__item">
        <label className="PaymentSummary__label">Test Date</label>
        <span className="PaymentSummary__value">

          {tryFormatDate( data?.evaluatedDate,
                          DateFormats.MonthNameFormat
                        )}
        </span>
      </div>
    );
  };


    return (
      <>
      {Object.keys(data).length > 0  &&
      <div className="Registration py-5 mt-lg-0 mb-5 bg-gray" style={{backgroundColor:"#80808012"}}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-10 col-lg-11 col-12">
              <div className="pb-md-5 pb-4 font-weight-normal text-left">
                 <div className="PaymentSummary mb-4" style={{border:"1px solid #ddd",boxShadow:"0px 10px 13px -7px #ddd, 5px 4px 13px 1px rgba(221,221,221,0) !important"}}>
                      <div className="PaymentSummary__row">
                        {renderTotalScore()}
                        {testDate()}
                        {renderRemarks()}
                      </div>
                    </div>
                   <GeneralInformation user={data.userData} course={data.courseData} eysightCheck={data?.eyeSight || false} />
          
                  <div className="bg-white rounded white-box px-md-4 px-3 py-4 mb-0" style={{border:"1px solid #ddd",boxShadow:"0px 10px 13px -7px #ddd, 5px 4px 13px 1px rgba(221,221,221,0) !important"}}>
                     <h6 className="pb-4 mt-md-3 text-primary">Technical Skills</h6>
                         {data.performanceCheckList.map((item:any, index:any) => {
                           return (
                             <>
                              <h6 className="font-family mb-0"  style={{ backgroundColor: '#989898',padding: 10, color: "white",fontWeight: "bold"}}>
                                 {item?.name}
                             </h6>
                              <CheckList item={item.subCategory} />
                
                            </>
                           )
                         })
                         }
                   </div>       
            
              </div>
              </div>
              </div>
              </div>
         </div>
       }
      </>

    );
  
}

export default DefensiveReport;
